<template>
    <div class="card-box m-b-10 p-10 relative card_color_left" :style="`border-left-color: ${getSegmentColor(item.segment)}`">
        <div class="table-box table_fixed table_deals">

            <div class="table-detail w_30">
                <div class="clearfix">
                    <pml-checkbox v-model="selected" @input="isSelected"></pml-checkbox>
                </div>
            </div>
            <!-- Infos -->
            <div class="table-detail">
                
                <router-link :to="{ name: 'deals.show', params: { id: item.id } }" target="_blank">
                    <strong class="m-t-0 m-b-5 f_size_14">
                        #{{ item.code }}
                        <span v-if="item.lead.first_name"> - {{ item.lead.first_name }} {{ item.lead.last_name }}</span>
                    </strong>
                </router-link>
                <small class="c_default show bold t_overflow" v-if="item.lead.email">{{ item.lead.email }}</small>
            </div>

            <div class="table-detail">
                <div class="row">

                    <!-- Consultant -->
                    <div class="col-xs-12 col-sm-6 col-md-12">
                        <span class="text-muted" v-if="item.member" v-pml-tooltip="$t('consultant')">
                            <i class="md-headset-mic text-dark"></i> {{ item.member.full_name }}
                        </span>
                    </div>

                    <!-- Follower -->
                    <div class="col-xs-12 col-sm-6 col-md-12">
                        <small class="text-muted" v-if="item.follower" v-pml-tooltip="$t('follower')">
                            <i class="fa fa-location-arrow text-dark m-r-5"></i> {{ item.follower.full_name }}
                        </small>
                    </div>

                </div>
            </div>

            <!-- Source -->
            <div class="table-detail t_center">
                <span class="label label-default" :style="`background-color:${item.source.color}`" v-pml-tooltip="$t('source')" v-if="item.source">{{ item.source.name }}</span>
            </div>

            <!-- Perception -->
            <div class="table-detail table_divider_mobile t_center w_100">
                <span v-if="item.perception" class="label" :class="getPerceptionColor(item.perception)" v-pml-tooltip="$t('perception')">
                    {{ $t(item.perception) }}
                </span>
            </div>

            <!-- Actions -->
            <div class="table-detail table_divider_mobile table-actions-bar t_right w_100">
                <span v-if="item.status !== 'open'" class="status_deal" :class="{ 'sold': item.status === 'sold', 'lost': item.status === 'lost' }">{{ $t(item.status) }}</span>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import bus from 'utils/events/bus'

    export default {
        name: 'Item',
        data () {
            return {
                selected: false
            }
        },
        props: {
            item: {
                type: Object,
                default: () => {}
            }
        },
        created () {
            bus.$on('selectedAll', (val) => { this.selected = val })
        },
        destroyed () {
            bus.$off('selectedAll')
        },
        computed: {
            ...mapGetters({
                'member': 'getMember'
            })
        },
        methods: {
            getSegmentColor (segment) {
                return segment ? segment.color : ''
            },
            getPerceptionColor (persption) {
                if (persption === 'hot') return 'label-danger'
                if (persption === 'cold') return 'label-primary'
                if (persption === 'warm') return 'label-warning'
                if (persption === 'no_perception') return 'label-light'
            },
            isSelected (val) {
                val ? this.addSelected() : this.removeSelected()
            },
            addSelected () {
                bus.$emit('addSelected', [this.item.id])
            },
            removeSelected () {
                bus.$emit('removeSelected', [this.item.id])
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/emails/massive/components/Item.vue